import { render, staticRenderFns } from "./MyShippingDetails.vue?vue&type=template&id=e16e4dde&scoped=true&"
import script from "./MyShippingDetails.vue?vue&type=script&lang=js&"
export * from "./MyShippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyShippingDetails.vue?vue&type=style&index=0&id=e16e4dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16e4dde",
  null
  
)

export default component.exports